
      import { adobeAnalyticsDataUrl } from './src/ts/analytics-loader.ts';
      const script = document.createElement('script');
      script.src = adobeAnalyticsDataUrl;
      script.async = true;
      script.onerror = function() {
        console.error('Failed to load the new analytics script');
      };
      document.head.appendChild(script);
    